import { CloseOutlined } from "@ant-design/icons";
import {
  CloseButton,
  ConfirmationModal,
  GridCell,
  GridContainer,
  GridHeader,
  HistoryGridRow,
  ModalHeader,
  OverlayStyle,
} from "../../../styles";
import { Separator } from "../../../../../styles/titles";
import {
  formatCommitValue,
  formatDateView,
  formatDivisionRuleView,
  formatMoneyView,
} from "../../../../../utils/formatViews";
import { ContractEffectHistoryData, HistoryModalValue } from "./types";

export const HistoryModal: React.FC<HistoryModalValue> = (props) => {
  const { isShowing, modalData, onClose } = props;

  if (!modalData) {
    return null;
  }

  return (
    <>
      {isShowing && (
        <>
          <OverlayStyle onClick={onClose} />
          <ConfirmationModal onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <h2>Hash da UR: {modalData?.hash}</h2>
              <CloseButton onClick={onClose}>
                <CloseOutlined />
              </CloseButton>
            </ModalHeader>

            <Separator />

            <GridContainer>
              <HistoryGridRow header>
                <GridHeader>Arquivo do Efeito</GridHeader>
                <GridHeader>Valor Comprometido</GridHeader>
                <GridHeader>Data e Hora Evento</GridHeader>
                <GridHeader>Identificador do Contrato</GridHeader>
                <GridHeader>Regra de Divisão</GridHeader>
                <GridHeader>Ordem do Contrato</GridHeader>
              </HistoryGridRow>

              {modalData.records.map(
                (transaction: ContractEffectHistoryData, index: number) => (
                  <HistoryGridRow key={index}>
                    <GridCell>{transaction?.effectFileName || "-"}</GridCell>
                    <GridCell>
                      {formatCommitValue(
                        transaction?.committedValue,
                        transaction?.divisionRules
                      )}
                    </GridCell>
                    <GridCell>
                      {transaction?.eventTimestamp
                        ? formatDateView(transaction.eventTimestamp)
                        : "-"}
                    </GridCell>
                    <GridCell>
                      {transaction?.contractIdentifier || "-"}
                    </GridCell>
                    <GridCell>
                      {transaction?.divisionRules
                        ? formatDivisionRuleView(transaction.divisionRules)
                        : "-"}
                    </GridCell>
                    <GridCell>
                      {transaction?.contractEffectIndicator || "-"}
                    </GridCell>
                  </HistoryGridRow>
                )
              )}
            </GridContainer>
          </ConfirmationModal>
        </>
      )}
    </>
  );
};
